
import Component, { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { SalaryCalculationsTable } from "@/UI/pages/SalaryСalculations/lib/table";

@Component({
    components: {
        PageTitle,
        BaseDataForm,
    }
})

export default class CosmetologCard extends mixins (ProxyTableData, SalaryCalculationsTable) {

    data_header: any = []
    data_footer: any = []

    addHeader() {
        this.data_header.push(
            {
                data1: '',
                data2: ''
            }
        )
    }
    addFooter() {
        this.data_footer.push(
            {
                data1: '',
                data2: ''
            }
        )
    }
    deleteData(num: any, index: any) {
        if (num === 1) {
            this.data_header.splice(index, 1)
        }
        if (num === 2) {
            this.data_footer.splice(index, 1)
        }
    }

    async created() {
        this.formReady = true
    }

}
